import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/es/messages';
import { messages as retailMessages } from '../translations/autohero-common/es/messages';

activateI18n('es', {
  ...retailMessages,
  ...sellOnlyMessages,
});
